module.exports = __webpack_public_path__ + "static/image_15-43c0612a48ce5a4e25b5112a4a11f656.jpg";